import {
  Card,
  CardContent,
  Divider,
  Link,
  IconButton as MuiIconButton,
} from '@material-ui/core';
import { Add, Edit } from '@material-ui/icons';
import { CardButton, Column, Columns, Stack } from '@superdispatch/ui';
import { Alert, TextBox } from '@superdispatch/ui-lab';
import { useNavigate } from 'react-router-dom';
import { MobileAppBridge } from 'shared/data/MobileAppBridge';
import { useCarrierInfo } from 'shared/modules/carrier-profile/data/CarrierInfoAPI';
import { useSubscriptionDetails } from 'shared/modules/subscription/SubscriptionAPI';
import { LinkAnchor } from 'shared/routing/Links';
import styled from 'styled-components';
import { SUBSCRIPTION_CONTACT_DESCRIPTION } from 'shared/modules/subscription/core/SubscriptionContactFields';

const IconButton = styled(MuiIconButton)`
  padding: 4px;
`;

const EDIT_SUBSCRIPTION_CONTACT_PATH =
  '/settings/subscription/edit_subscription_contact';

export function SubscriptionContactCard() {
  const navigate = useNavigate();
  const { data: subscriptionDetails } = useSubscriptionDetails();
  const { data: carrierInfo } = useCarrierInfo();
  const subscriptionContact = subscriptionDetails?.subscription?.contact;

  return (
    <Card>
      <CardContent>
        <Stack space="small">
          <Columns align="top">
            <Column width="fluid">
              <Stack space="xxsmall">
                <TextBox variant="heading-3">Subscription Contact</TextBox>
                <TextBox color="secondary">
                  {SUBSCRIPTION_CONTACT_DESCRIPTION}
                </TextBox>
              </Stack>
            </Column>
            {subscriptionContact && (
              <Column width="content">
                <IconButton
                  aria-label="edit subscription contact"
                  onClick={() => {
                    navigate(EDIT_SUBSCRIPTION_CONTACT_PATH);
                  }}
                >
                  <Edit fontSize="small" />
                </IconButton>
              </Column>
            )}
          </Columns>

          {subscriptionContact ? (
            <Stack space="xxsmall">
              <TextBox variant="body-semibold">
                {subscriptionContact.first_name} {subscriptionContact.last_name}
              </TextBox>
              <TextBox>{subscriptionContact.email}</TextBox>
            </Stack>
          ) : (
            <Stack space="small">
              <CardButton
                size="small"
                startIcon={<Add />}
                onClick={() => {
                  navigate(EDIT_SUBSCRIPTION_CONTACT_PATH);
                }}
              >
                Add Subscription Contact
              </CardButton>
              <Alert severity="caution">
                Add subscription contact so we can send all subscription related
                notices.
              </Alert>
            </Stack>
          )}

          {carrierInfo?.email && (
            <>
              <Divider />
              <TextBox color="secondary" variant="caption">
                Copies also go to {carrierInfo.email} (
                {MobileAppBridge.isInjected() ? (
                  <Link
                    component="button"
                    color="primary"
                    onClick={() => {
                      MobileAppBridge.openCarrierInformation();
                    }}
                  >
                    carrier profile
                  </Link>
                ) : (
                  <LinkAnchor color="primary" to="/profile/carrier_info">
                    carrier profile
                  </LinkAnchor>
                )}
                ).
              </TextBox>
            </>
          )}
        </Stack>
      </CardContent>
    </Card>
  );
}
